import { RequestConfig } from '@/interface'

const PRIFIX = 'adminUser/'
const accountConfig: RequestConfig = {
  addUser: {
    // 新增用户
    url: `${PRIFIX}addUser`,
    method: 'post'
  },
  excelImport: {
    // excel 导入员工
    url: `${PRIFIX}excelImport`,
    method: 'post'
  },
  setUser: {
    // 设置用户
    url: `${PRIFIX}setUser`,
    method: 'post'
  },
  getAllRoleList: {
    // 角色列表
    url: 'adminRole/getAllRoleList',
    method: 'post'
  },
  resetPassword: {
    // 重置密码
    url: `${PRIFIX}resetPassword`,
    method: 'post'
  },
  usernameEdit: {
    // 重置账户
    url: `${PRIFIX}usernameEdit`,
    method: 'post'
  },
  usernameEditByManager: {
    // 重置账户(可修改管理员)
    url: `${PRIFIX}usernameEditByManager`,
    method: 'post'
  },
  setUserStatus: {
    // 用户状态修改
    url: `${PRIFIX}setUserStatus`,
    method: 'post'
  },
  downExcel: {
    // 下载用户导入错误数据
    url: `${PRIFIX}downExcel`,
    method: 'post'
  },
  queryUserList: {
    // 员工列表
    url: `${PRIFIX}queryUserList`,
    method: 'post'
  }
}
export default accountConfig
